export default __webpack_public_path__ + "static/media/NIAS0400.34I-29077_-16912_0.d9e1a832.jpg";